// Login carousel — images shown on the iOS OnboardingView sign-in screen
// (PX-252). Thin wrapper over the shared MediaCarouselManager; CRUD hits
// /admin/login-images (PX-249), each mutation invalidates the public
// login_images:config Redis cache server-side. Uploads ride through
// MediaDropzone → /admin/media/upload (PX-247), persisting only the URL.

import { MediaCarouselManager } from '@/components/MediaCarouselManager'
import { PERM } from '@/types/api'

export function LoginCarouselPage() {
  return (
    <MediaCarouselManager
      title="Login carousel"
      description="Images shown on the app's sign-in screen. Order by sort value; toggle Active to hide without deleting. Takes effect without an app release."
      endpoint="/admin/login-images"
      queryKey={['admin', 'login-images']}
      writePerm={PERM.login_images_write}
      deleteConfirmText="Delete this login-carousel image? This removes it permanently."
    />
  )
}
